    $('.tt-input-counter').find('.minus-btn, .plus-btn').click(function( e ) {
      var $input = $(this).parent().find('input');
      var count = parseInt($input.val(), 10) + parseInt(e.currentTarget.className === 'plus-btn' ? 1 : -1, 10);
      $input.val(count).change(); 
    });
    
    $('.tt-input-counter').find("input").change(function() {
      var _ = $(this);
      var min = 1;
      var val = parseInt(_.val(), 10);
      var max = parseInt(_.attr('size'), 10);
      val = Math.min(val, max);
      val = Math.max(val, min);
      _.val(val);
    })
    .on("keypress", function( e ) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    });
    
    $('.addtocart-item-js').length && $('.addtocart-item-js').removeClass('addtocart-item-js');
    
    $('[name=update]').click(function(e){
      e.preventDefault();
      $('#updateform').submit();
    });

    $("#wrapper-response").bind("DOMNodeInserted",function(){
      
      if($("#wrapper-response").find('#shipping-rates').length == 0)
        return false;

      setTimeout(
        function(){
          var shopCurrency = ''; // Main Currency
          var shippingValueTotal = 0; // Default value Shipping
          var defaultCurrencySign = ''; // sign of the a currencies
          var curstr = $('#grandtotal .money').attr("data-currency-"+shopCurrency.toLowerCase());

          if(!curstr) return false;
          for (var i = 0; i < curstr.length; i++) {
            if(Number.isInteger(parseInt(curstr.charAt(i)))) { break; }
            defaultCurrencySign += curstr.charAt(i);
          }

          //check shipping TAX
          if($("#wrapper-response #shipping-rates .money").length >= 1) {
            if($("#wrapper-response #shipping-rates .money").length > 1) {
              var str = "Translation missing: zh-TW.cart.general.shipping_variants";
              if(str == "") {
                $("#tax").hide();
                return false;
              }
              $("#tax .money").text(str);
              $("#tax").show();
              return false;
            }
            var content = $("#wrapper-response .money").clone();
            $("#tax .money").replaceWith(content);
            $("#tax").show();
            var shippingValueTotal = parseFloat($("#wrapper-response .money").text().replace(/[^0-9\.]/g,'')); //get Tax price
          }
          else {
            $("#tax").hide();
          }

          //get Tax price
          var tofindpoint = Number(Number($('[data-total-price]').attr('data-total-price'))/100).toFixed(2);//$('#subtotal .money').attr("data-currency-"+shopCurrency.toLowerCase()).replace(/[^0-9\.]/g,'');
          var defaultValueSubtotal = parseFloat(tofindpoint);
          //full price
          var grandtotal = defaultValueSubtotal + shippingValueTotal;
          //format to this 1,000,000.00 or 1,000,000
          grandtotal = format(grandtotal, tofindpoint);
          //for #grandtotal element
          var dataCurrencyDefault = defaultCurrencySign+grandtotal;
          //create full price with shipping
          jQuery('#grandtotal .money').replaceWith('<span class="money" data-currency-'+shopCurrency.toLowerCase()+'="'+dataCurrencyDefault+'">'+dataCurrencyDefault+'</span>');
          $('body').trigger('refreshCurrency');

        },0
      );

      function format(n, k) {
        var sum = '';
        var group1 = 1000000000;
        var group2 = 1000000;
        var group3 = 1000;
        var sep = "."; // Default to period as decimal separator
        var decimals = 2; // Default to 2 decimals
        var isDecimal = k.toString(10).indexOf(".")==-1;

        var num = Math.floor(n);
        var x = Math.floor(num / group1);
        if(x > 0) {
          x = decimalWithZero(sum, x);			 
          sum = x + ",";
          num -= x * group1;
        }
        x = Math.floor(num / group2);
        if(x > 0 || sum != '') {
          x = decimalWithZero(sum, x);
          sum += x + ",";
          num -= x * group2;
        }
        x = Math.floor(num / group3);
        if(x > 0 || sum != '') {
          x = decimalWithZero(sum, x);
          sum += x + ",";
          num -= x * group3;
        }

        x = decimalWithZero(sum, num);
        sum += x;
        n = n.toFixed(decimals).split(sep)[1];

        if(isDecimal) {
          return sum;
        }
        else {
          return sum + sep + n;
        }
      }
      function decimalWithZero(sum, x) {
        if(sum != ''){
          var y = '000' + x;
          y = y.substr(y.length - 3);
          return y;
        }
        return x;
      }
    });

    $("input:not([type=checkbox])").change(function(){
      $("[name=update]").addClass("blink-border");
      var v = Number($(this).val()),
          s = Number($(this).attr('size')),
          p = $(this).parent();
      v <= 1 ? p.find('.minus-btn').hide() : p.find('.minus-btn').show();
      v >= s ? p.find('.plus-btn').hide() : p.find('.plus-btn').show();
    });
    $("textarea").change(function(){
      $("[name=update]").addClass("blink-border");
    });